<template>
  <div class="c-rankIcon">
    <BalloonDropdown
      position="is-bottom-right"
      :triggers="['hover']"
      width="300px"
      v-if="isPC"
    >
      <a
        class="c-rankIcon_dropdownTrigger"
        href="javascript:;"
        slot="trigger"
      >
        <img
          :src="$coconala.levelIconURL(levelValue)"
          alt=""
          :style="styles"
        >
      </a>
      <div
        class="c-rankIcon_help"
        @click.stop.prevent
      >
        <div class="c-rankIcon_helpTitle">
          <strong>出品者ランク：{{ levelNameText }}</strong>
        </div>
        <div class="c-rankIcon_helpText" v-html="generateLevelHelpText(levelValue)" />
        <div class="c-rankIcon_helpImage">
          <img
            src="@/assets/images/common/level-balloon.png"
            class="popover-rank-image"
            width="261"
          >
        </div>
        <div class="c-rankIcon_helpLink">
          <a
            href="javascript:;"
            @click="openLinkBlank('/pages/about_rank')"
          >
            詳しくはこちら
            <CoconalaIcon name="chevron-right" />
          </a>
        </div>
      </div>
    </BalloonDropdown>
    <div
      v-else
      class="c-rankIcon_imageWrap"
    >
      <img
        :src="$coconala.levelIconURL(levelValue)"
        alt=""
        loading="lazy"
        :style="styles"
      >
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BalloonDropdown from '~/components/molecules/BalloonDropdown'

export default {
  name: 'RankIcon',
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    levelValue: {
      type: Number,
      required: true
    },
    levelNameText: {
      type: String,
      required: true
    }
  },
  components: {
    BalloonDropdown
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    styles() {
      return {
        width: this.width
      }
    }
  },
  methods: {
    generateLevelHelpText(level) {
      if (level === 1) {
        return '<p>累積の販売実績が<strong>1件</strong>以上の出品者です。</p>'
      } else if (level === 2) {
        return '<p>累積の販売実績が<strong>10件</strong>以上あり、納品完了率<strong>80％</strong>以上の基準をクリアした出品者です。</p>'
      } else if (level === 3) {
        return '<p>直近3ヶ月間で一定の販売実績があり、納品完了率<strong>85%</strong>以上の基準をクリアした出品者です。</p>'
      } else if (level === 4) {
        return '<p>直近3ヶ月間で一定の販売実績があり、納品完了率<strong>90%</strong>以上、評価<strong>4.8</strong>以上の基準をクリアし、本人確認済みの信頼性の高い出品者です。</p>'
      } else if (level === 5) {
        return '<p>直近3ヶ月間で一定の販売実績があり、納品完了率<strong>90%</strong>以上、評価<strong>4.8</strong>以上の基準をクリアし、本人確認済みの信頼性の高い出品者です。</p>'
      }
      return ''
    },
    openLinkBlank(path) {
      open(path, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.c-rankIcon {
  &_help {
    padding: 8px 12px;
    font-size: 12px;
  }

  &_helpTitle {
    border-bottom: 1px solid $color-white;
    padding-bottom: 8px;
    margin-bottom: 8px;
    text-align: center;
    strong {
      color: $color-white;
    }
  }

  &_helpText {
    text-align: left;
    font-weight: normal;

    /deep/ strong {
      color: $color-white;
      font-weight: bold;
    }
  }

  &_helpImage {
    text-align: center;
    margin-bottom: 16px;
  }

  &_helpLink {
    text-align: right;
    font-weight: normal;

    a {
      color: $color-white;
    }
  }

  &_imageWrap {
    display: inline-flex;
  }

  /deep/ .dropdown {
    &-trigger {
      &::after {
        border: 0;
        background: #5f5f5f; // 吹き出しの矢印部分をなじませるため色を直指定
      }
    }
  }

  /deep/ .dropdown-menu {
    left: -180px;

    .dropdown-content {
      border: 0;
      background: rgba(51, 51, 51, 0.8);
      color: $color-white;
      cursor: default;
    }
  }
}
</style>
